module.exports = __webpack_public_path__ + "static/media/search.ace6b4ea.svg";